{
    "TITLE" : "Aplicación Remota",
    
        "SHARED": {
            "INTERNET_OFFLINE": "Tu conexión a internet parece estar desactivada.",
            "LANGUAGE": "Idioma",
            "NO_FEATURE": "Su licencia no posee ésta característica. Por favor contacte a su administrador.",
            "FEATURE_UNAVAILABLE": "Su licencia no contiene ésta característica.",
            "APP_UPDATE_NEEDED": "To use this feature, this participant needs to update their app.",
            "TRAINING_DISABLED": "No tienes permiso para usar esta función. Solicite permiso al anfitrión."
        },
        "UPDATE_MODAL": {
            "TITLE": "Actualización Disponible",
            "MESSAGE": "Nueva versión disponible. Esta página se actualizará despues de la actualización.",
            "UPDATE": "Recargar",
            "UPDATE_FAILED": "Actualización Fallida"
        },
        "LOGIN" : {
        "SSO-BUTTON": "Iniciar sesión con SSO",
            "APP_NAME": "{{ appName }} Remoto",
            "TITLE": "Conectar a la Aplicación Remota",
            "ACCOUNT_PLACEHOLDER" : "Nombre de la Cuenta",
            "ACCOUNT_REQUIRED" : "El nombre de la cuenta es requerido.",
            "ACCOUNT_SHORT" : "El nombre de la cuenta debe tener al menos 2 caractéres.",
            "USERNAME_PLACEHOLDER" : "Nombre de usuario",
            "USERNAME_REQUIRED" : "Debe ingresar un nombre de usuario.",
            "USERNAME_SHORT" : "El nombre de usuario debe tener al menos dos caractéres.",
            "PASSWORD_PLACEHOLDER" : "Contraseña",
            "PASSWORD_REQUIRED" : "Debe ingresar una contraseña.",
            "PASSWORD_SHORT" : "La contraseña debe tener al menos 6 caractéres.",
            "REMEMBER_ACCOUNT_NAME": "Recordar nombre de cuenta",
            "VERIFICATION_CODE": "Código de Verificación",
            "TWO_FACTOR_EMAIL_SENDED": "Te hemos enviado un código de verificación.",
            "VERIFY_BUTTON": "VERIFICAR",
            "LOGIN_BUTTON" : "INICIAR SESION",
            "BACK_BUTTON" : "VOLVER",
            "BEFORE_TERMS": "Al iniciar sesión, aceptas nuestros ",
            "TERMS": "Términos de Servicio",
            "CONJUNCTION": " y ",
            "PRIVACY": "Política de Privacidad",
            "AFTER_PRIVACY": ".",
            "GUEST_DELETED": "Te has desconectado.",
            "USER_DELETED": "Tu cuenta ha sido eliminada. Contacta con tu administrador.",
            "USER_DISABLED": "Tu cuenta ha sido deshabilitada. Contacta con tu administrador.",
            "LOGGED_IN_ANOTHER_SESSION": "Ya estás conectado en otra sesión.",
            "LOGGED_OUT_UNKNOWN": "Algo no salió bien.",
            "NO_INTERNET_ERROR": "Sin Internet. Por favor verifique su conexión.",
            "USERNAME_PASSWORD_ERROR" : "El nombre de cuenta, nombre de usuario o contraseña son incorrectos.",
            "ACCOUNT_DISABLED": "Tu cuenta ha expirado. Por favor contactanos en {{ contactMail }}",
            "INVALID_VERIFICATION_CODE" : "Código de verificación de dos pásos incorrecto.",
            "UNKNOWN_ERROR" : "Ocurrió un error al iniciar sesión.",
            "SIMULTANE_LOGIN_ERROR": "Estás conectado en otra sesión.",
            "USE_CHINA_SERVERS": "Estoy iniciando sesión desde China",
            "CHINA_SERVERS_CAUTION": "Esta opción puede provocar latencia fuera de China continental.",
            "MULTI_LOGIN_MODAL": {
                "TITLE": "Inicio de Sesión Múltiple",
                "MESSAGE": "Su usuario ya ha iniciado sesión en otro dispositivo. Si continúa, se cerrará la sesión del otro usuario.",
                "CANCEL": "Cancelar",
                "PROCEED": "Continuar"
            }
        },
        "MAIN" : {
            "LICENSE_LEFT": "Tienes {{ days }} días restantes en tu licencia remota de {{ appName }} .",
            "DEMO_LEFT": "Tienes {{ days }} días restantes en tu periodo de prueba de {{ appName }}",
            "LEFT_BAR": {
                "LOBBY": "Vestíbulo",
                "ROOMS": "Salas",
                "MEETINGS": "Reuniones",
                "FEEDBACK": "Realimentación",
                "CONTACTS": "Usuarios",
                "SESSIONS": "Sesiones",
                "TICKETS": "Tickets",
                "PRECALL_TEST": "Comprobación de conexión",
                "WHATS_NEW": "Qué hay de nuevo",
                "PROFILE": "Perfil",
                "HELP_CENTER": "Centro de ayuda",
                "LOGOUT": "Cerrar sesión"
            },
            "CALL_MESSAGE": {
                "TITLE":"Llamada entrante de <strong>{{ caller_name }}</strong>",
                "DENY": "Negar",
                "ACCEPT": "Aceptar"
            },
            "GET_EXPORT_MODAL": {
                "TITLE": "Obtener Sesión de Exportación",
                "MESSAGE1": "Ingrese su dirección de correo electrónico para recibir el enlace de descarga de exportación de la sesión una vez que finalice la sesión.",
                "MESSAGE2": "La exportación de la sesión incluirá todos los <strong>mensajes de chat</strong>, <strong>instantáneas</strong>, <strong>registros de videollamadas</strong> y <strong>archivos</strong> compartidos en la sesión.",
                "EXPORT_NAME_NOT_LOCKED": "Puede cambiar el nombre del archivo de exportación ingresando un nombre de archivo personalizado en su lugar.",
                "EXPORT_NAME_LOCKED": "Podrá cambiar el nombre del archivo de exportación tan pronto como el otro usuario haya completado la exportación.",
                "EXPORT_NAME_RENAMED": "Este usuario cambia el nombre del archivo de exportación:",
                "EXPORT_NAME_PLACEHOLDER": "Nombre de exportación",
                "NOTE": "Nota: puede actualizar su dirección de correo electrónico desde el menú de perfil.",
                "NOTE2": "Nota: puede actualizar su dirección de correo electrónico a través de su administrador.",
                "OPEN_PROFILE": "Perfil abierto",
                "EMAIL": "Email",
                "EMAIL_REQUIRED": "Email electronico requerido.",
                "EMAIL_INVALID": "Formato de email inválido.",
                "CLOSE": "Cerca",
                "SEND": "Enviar",
                "EXPORT_SUCCEEDED": "La exportación de la sesión se enviará una vez que finalice la sesión.",
                "ENDED_SESSION_EXPORT_SUCCEEDED": "Se envía la exportación de la sesión.",
                "EXPORT_FAILED": "Ocurrió un error."
            },
            "EASY-ACCESS": {
                "MANAGE-PUBLIC-ACCESS": "Gestionar acceso público",
                "MANAGE-PUBLIC-ACCESS-TEXT": "Puede dejar de compartir este flujo de trabajo eliminando el acceso público.",
                "GENEATE-ACCESS-TEXT": "Puede generar un enlace público y un código QR para crear un acceso fácil para este flujo de trabajo.",
                "ENABLE-PASSWORD": "Habilitar contraseña",
                "GENERATE-ACCESS": "Generar",
                "LINK": "Enlace",
                "COPY": "Copiar",
                "QR-CODE": "Código QR",
                "DOWNLOAD": "Descargar",
                "SECURITY": "Seguridad",
                "PASSWORD-PROTECTED": "Protegido con contraseña",
                "PUBLIC": "Público",
                "DELETE-ACCESS": "Eliminar acceso público",
                "EASY-ACCESS-TITLE": "{{ shortName }} Acceso fácil al flujo de trabajo",
                "OPEN-WORKFLOW-NAME": "Está a punto de abrir",
                "GUEST-EMAIL": "Correo electrónico de invitado",
                "REQUIRED": "Este campo es obligatorio",
                "GUEST-PASSWORD": "Contraseña para invitados",
                "OPEN": "ABRIR",
                "OPEN-APP": "Sugerimos abrir este flujo de trabajo en nuestra aplicación para una mejor experiencia.",
                "COPY-LINK-TEXT": "Copie el enlace al portapapeles para abrir este flujo de trabajo cuando se inicie la aplicación.",
                "DOWNLOAD-APP": "DESCARGAR APLICACIÓN",
                "DOWNLOAD-SMARTGLASSES-APP": "DESCARGAR APLICACIÓN PARA GAFAS INTELIGENTES",
                "OR": "O",
                "CONTINUE-WITH-BROWSER": "Continuar con el navegador",
                "PASSWORD-PROTECTED-TEXT": "Cuando la contraseña está habilitada, los usuarios que tienen el enlace público o el código QR solo pueden acceder a este flujo de trabajo al ingresar la contraseña.",
                "CREATE-PASSWORD": "Crear contraseña",
                "ENTER-EMAIL": "Ingrese su correo electrónico",
                "ENTER-WORKFLOW-PASSWORD": "Ingrese la contraseña del flujo de trabajo",
                "DELETE-QR-TEXT": "Para cambiar el tipo de seguridad de Acceso fácil, debe eliminar Acceso fácil y generar nuevamente.",
                "LOADING-WORKFLOW": "Cargando flujo de trabajo...",
                "UNABLE-TO-LOAD": "No se puede cargar el flujo de trabajo",
                "RETRY": "Reintentar",
                "GUEST-ACCESS": {
                    "TOKEN-MISSING": "Token faltante o inválido",
                    "ID-MISSING": "Falta la ID del flujo de trabajo o la URL base",
                    "WORKFLOW-NOT-PUBLISHED": "El flujo de trabajo no está publicado",
                    "PUBLIC-ACCESS": "El acceso público ya existe",
                    "NO-PUBLIC-ACCESS": "No hay acceso público"
                },
                "QR-INFORMATION": "Información QR"
            },
            "VIDEO-FLOW-DASHBOARD": {
                "TITLE": "Flujos de video",
                "CREATE-VIDEO-FLOW": "Crear flujo de video",
                "CREATED-BY-AI": "Creado por IA",
                "VERSION": "Versión",
                "NO-VIDEO-FLOWS-FOUND": "No se encontraron flujos de video",
                "CLEAR-ALL": "Limpiar todo",
                "CONFIRM-VIDEO": "Confirmar video",
                "CONFIRM-VIDEO-TITLE": "Confirmar conversión de video",
                "CONFIRM-VIDEO-MESSAGE": "¿Está seguro de que desea convertir este flujo de video en un flujo de trabajo? Después de la confirmación, no podrá editar el video.",
                "CONFIRM-VIDEO-BUTTON": "Confirmar y convertir",
                "MAKE-WORKFLOW-SUCCESSFUL": "Convertido a flujo de trabajo exitosamente",
                "MAKE-WORKFLOW-ERROR": "Error al convertir a flujo de trabajo",
                "UPLOAD-VIDEO-DESCRIPTION": "Suba su video para generar automáticamente una guía de flujo de trabajo paso a paso.",
                "VIDEO-DURATION-LIMIT": "La duración del video no puede exceder los 30 minutos.",
                "VIDEO-UPLOADED-SUCCESS": "¡Video subido exitosamente!",
                "SELECT-VIDEO": "Seleccionar video",
                "CHANGE-VIDEO": "Cambiar video",
                "CREATE-BUTTON": "Crear",
                "AI-PROCESSING": "Procesamiento de IA en curso",
                "SPLITTING-VIDEO": "Dividiendo video en segmentos",
                "TRANSCRIBING-VIDEO": "Transcribiendo contenido del video",
                "PROCESS-WARNING": "Este proceso puede tardar hasta 10 minutos. Por favor, no cierre esta ventana."
            },
            "NAVBAR" : {
                "PRECALL_TEST": "Comprobación de conexión",
                "PRECALL_END_SESSION": "Por favor finaliza la sesión antes de realizar la comprobación de conexión.",
                "LOGOUT" : "Cerrar sesión",
                "LANGUAGE" : "Idioma",
                "LOGOUT_MODAL_TITLE": "Cerrar sesión?",
                "LOGOUT_MODAL_MESSAGE": "Esta acción te desconectará.",
                "CAUTION": "Precaución: Esto cerrará su sesión sin finalizar la sesión. Las ventanas emergentes y otra información después de la sesión pueden perderse (por ejemplo, exportación de la sesión).",
                "LOGOUT_MODAL_MESSAGE_IN_ROOM": "Saldrá de la sesión y cerrará la sesión.",
                "LOGOUT_MODAL_NO": "Cancelar",
                "LOGOUT_MODAL_YES": "Aceptar",
                "LOGOUT_FAILED": "Ocurrió un error al cerrar sesión",
                "HELP_CENTER": "Centro de ayuda",
                "PROFILE_TITLE": "Perfil",
                "PROFILE_NAME": "Nombre",
                "PROFILE_EMAIL": "Email",
                "PROFILE_PASSWORD": "Contraseña",
                "PROFILE_CHANGE_LINK": "Cambio",
                "PROFILE_ADD_LINK": "Agregar",
                "PROFILE_CLOSE": "Cerrar",
                "CHANGE_PASS_TITLE": "Cambiar contaseña",
                "CHANGE_PASS_OLD_PASS": "Contraseña anterior",
                "CHANGE_PASS_NEW_PASS": "Contraseña nueva",
                "CHANGE_PASS_RPT_PASS": "confirmar Contraseña",
                "CHANGE_PASS_REQUIRED": "Debe ingresar una contraseña.",
                "CHANGE_PASS_NOT_MATCH": "Las contraseñas no coinciden.",
                "CHANGE_PASS_CLOSE_BTN": "Cerrar",
                "CHANGE_PASS_CHANGE_BTN": "Cambiar contraseña",
                "CHANGE_PASS_SUCCESS": "Tu contraseña ha cambiado.",
                "CHANGE_PASS_WRONG": "Tu contraseña está incorrecta.",
                "CHANGE_PASS_FAILED": "Ha ocurrido un error al cambiar la contraseña.",
                "CHANGE_EMAIL_TITLE": "Cambiar e-mail",
                "CHANGE_EMAIL_NEW_EMAIL": "Nuevo e-mail",
                "CHANGE_EMAIL_RPT_EMAIL": "Confirmar e-mail",
                "CHANGE_EMAIL_REQUIRED": "Correo electronico es requerido.",
                "CHANGE_EMAIL_NOT_VALID": "El correo no es válido.",
                "CHANGE_EMAIL_NOT_MATCH": "Las direcciones de correo electrónico no coinciden.",
                "CHANGE_EMAIL_CLOSE_BTN": "Cerrar",
                "CHANGE_EMAIL_CHANGE_BTN": "Cambiar e-mail",
                "CHANGE_EMAIL_SUCCESS": "Tu correo electrónico ha cambiado.",
                "CHANGE_EMAIL_FAILED": "Error en el cambio de correo electrónico.",
                "FEEDBACK": "Feedback",
                "SUCCESS_MESSAGE": "Gracias por enviar el formulario. Nuestro equipo se comunicará contigo en breve.",
                "CLOSE": "Cerrar",
                "CREATE_NEW_PASS": "Requisitos de contraseña",
                "UPPERCASE": "Mayúsculas",
                "LOWERCASE": "Minúscula",
                "NUMBER": "Número",
                "SPECIAL": "Especial",
                "AT_LEAST_PASSWORD_LENGTH": "Al menos {{passwordlength}} caracteres",
                "OLD_PASSWORD": "Contraseña anterior",
                "NOT_WHITESPACE": "Tu contraseña no debe contener espacios",
                "DO_NOT_CREATE_SIMPLE": "No cree contraseñas débiles como '123456'",
                "STATUS": {
                    "AVAILABLE": "Disponible",
                    "BUSY": "Ocupada",
                    "APPEAR_OFFLINE": "Aparecer desconectado"
                }
            },
            "LOBBY" : {
                "LOBBY_SHARED": {
                    "ONGOING_CALLS_TITLE": "Llamadas en Curso",
                    "ROOMS_TITLE": "Tus salas",
                    "UPCOMING_MEETINGS_TITLE" : "Próximas reuniones",
                    "PREVIOUS_MEETINGS_TITLE" : "Reuniones anteriores",
                    "SCHEDULE_MEETING": "Programar reunión",
                    "INSTANT_GUEST_ACCESS": "Acceso instantáneo para invitados",
                    "INSTANT_GUEST_ACCESS_NO_CALLING": "No tienes permiso para hacer llamadas. Por favor, contacta con tu administrador.",
                    "INSTANT_GUEST_ACCESS_NO_GUEST_ACCESS": "No tienes permiso para crear un enlace de acceso para invitados. Por favor, contacta con tu administrador.",
                    "INSTANT_GUEST_ACCESS_NO_PERM": "No tienes permiso para hacer llamadas ni crear un enlace de acceso para invitados. Por favor, contacta con tu administrador.",
                    "LINK_UNAVAILABLE": "Enlace no disponible",
                    "JOIN" : "UNIRSE",
                    "CANCEL": "CANCELAR",
                    "REMOVE": "RETIRAR",
                    "NO_ROOM": "No posees ninguna sala.",
                    "NO_MEETING": "No tienes ninguna reunión.",
                    "NO_PREV_MEETING": "No tienes ninguna reunión.",
                    "NO_OTHER_USERS": "No hay otros usuarios.",
                    "SHOW_MORE": "mostrar {{count}} más",
                    "SHOW_LESS": "muestra menos"
                },
                "SCHEDULE_MEETING_MODAL": {
                    "TITLE": "Programar reunión",
                    "MEETING_TITLE": "Título*",
                    "MEETING_TITLE_REQUIRED": "Título requerido.",
                    "START_DATE": "Comienzo",
                    "END_DATE": "Final",
                    "CLOSE": "Cerca",
                    "SCHEDULE_SEND": "Calendario y Enviar",
                    "SCHEDULE": "Calendario",
                    "CANNOT_SCHEDULE": "Se produjo un error al programar la reunión.",
                    "CANNOT_CANCEL_MEETING": "Se produjo un error al cancelar la reunión.",
                    "ENTER_USERS": "Ingresar usuarias",
                    "SEND_INVITATIONS": "Enviar invitaciones",
                    "INVITATION_EMAIL_LANG": "Idioma del correo electrónico de invitación",
                    "SHARE_AFTER": "El enlace de la reunión también se puede compartir después de la programación."
                },
                "CANCEL_MEETING_MODAL": {
                    "CANCEL_TITLE": "Cancelar reunión",
                    "REMOVE_TITLE": "Eliminar reunión",
                    "CANCEL_MESSAGE": "¿Está seguro de que desea cancelar la reunión?",
                    "REMOVE_MESSAGE": "¿Estás segura de que quieres eliminar la reunión?",
                    "CLOSE": "Cerca",
                    "PROCEED": "Continuar"
                },
                "CONTACTS": {
                    "TITLE": "Usuarios",
                    "NO_CONTACT": "La lista de usuarios está vacía.",
                    "NO_PERMISSION": "No tienes permiso para ver la lista de usuarios y llamar.",
                    "SELECT_MULTI": "Seleccionar Varios",
                    "CALL": "Llamada",
                    "ADMIN": "Admin",
                    "COADMIN": "Co-Admin",
                    "EXPERT": "Expert",
                    "SUBSCRIBER": "Subscriber",
                    "USER": "User",
                    "NAME": "Nombre",
                    "USERNAME": "Nombre de usuario",
                    "ROLE": "Papel",
                    "NO_EXPERT": "Seleccione al menos un experto para realizar una llamada.",
                    "NAME_USERNAME": "Nombre o nombre de usuario",
                    "ALL_ROLES": "Todos los roles"
                },
                "SESSIONS": {
                    "TITLE": "Sesiones",
                    "DATE": "Creado en",
                    "DURATION": "Duración total",
                    "ROOM_NAME": "Habitación",
                    "NO_SESSIONS": "La lista de sesiones está vacía.",
                    "PARTICIPANTS": "Las participantes",
                    "EXPORT": "Exportación",
                    "STATUS": "Estado",
                    "ON_GOING": "En curso",
                    "ENDED": "Terminado",
                    "FILES": "Archivos",
                    "CHAT": "Chat",
                    "SESSION_FILES": {
                        "MULTIPLE_SELECTION": "Seleccionar Varios",
                        "DOWNLOAD": "Descargar",
                        "DOWNLOAD_STARTED_SOON": "La descarga comenzará pronto.",
                        "DOWNLOAD_FAILED": "Descarga fallida.",
                        "NO_FILE_IS_ADDED": "No se agrega ningún archivo.",
                        "SUCCESS_MESSAGE": "Los archivos se han descargado correctamente."
                    },
                    "ATTACHED_TICKET": "Boleto adjunto",
                    "SESSION_DETAILS": "Detalles de la sesión",
                    "BACK": "Atrás",
                    "GET_SESSION_EXPORT": "Obtener exportación de sesión",
                    "ATTACH_TO_TICKET": "Adjuntar al ticket"
                },
                "TICKETS": {
                    "TITLE": "Entradas",
                    "NEW_TICKET": "Nuevo ticket",
                    "ALL_ROOMS": "Todas las habitaciones",
                    "ALL_STATUSES": "Todos los estados",
                    "NO_TICKETS": "La lista de entradas está vacía.",
                    "TICKET_TITLE": "Título",
                    "ROOM": "Habitación",
                    "CREATED_BY": "Creado por",
                    "CREATED_ON": "Creado en",
                    "STATUS": "Estado",
                    "STATUS_OPEN": "abierta",
                    "STATUS_IN_PROGRESS": "en curso",
                    "STATUS_CLOSED": "cerrada",
                    "CLOSE_PICK_TICKET": "CERRAR",
                    "CREATE_NEW": "CREAR NUEVO",
                    "ATTACH": "ADJUNTAR",
                    "CREATE_TICKET": "Crear Ticket",
                    "TICKET_DETAILS": "Detalles de la entrada",
                    "EDIT": "EDITAR",
                    "TICKET_TYPE": "Tipo de entrada",
                    "ROOM2": "Habitación: ",
                    "CREATED_BY2": "Creado por: ",
                    "CREATED_ON2": "Creado en: ",
                    "ROOM3": "Habitación",
                    "STATUS2": "Estado",
                    "PRIORITY": "Prioridad",
                    "ASSIGNEE": "Cesionaria",
                    "FOLLOW_UP": "Fecha de seguimiento",
                    "TICKET_TITLE2": "Título",
                    "TITLE_REQUIRED": "Título requerido",
                    "DESCRIPTION": "Descripción",
                    "DESCRIPTION_REQUIRED": "Descripción requerida",
                    "RESOLUTION": "Resolución",
                    "ATTACHED_SESSIONS": "SESIONES ADJUNTAS",
                    "NO_ATTACHED_SESSIONS": "La lista de sesiones adjunta está vacía",
                    "SESSION_COUNT": "Recuento de sesiones: ",
                    "TOTAL_DURATION": "Duración total: ",
                    "PARTICIPANTS2": "Las participantes:",
                    "COUNT_SESSIONS": " {{count}} Sesiones",
                    "DATE": "Fecha",
                    "ROOM_NAME": "Nombre de la habitación",
                    "PARTICIPANTS": "Las participantes",
                    "DURATION": "Duración",
                    "GUEST": "(Invitada)",
                    "CANCEL": "CANCELAR",
                    "CLOSE": "CERRAR",
                    "SAVE": "SALVAR",
                    "CREATE": "CREAR",
                    "CREATED_BETWEEN": "Creado entre",
                    "ALL_CREATORS": "Todas las creadoras",
                    "SEND_VIA_EMAIL": "ENVIAR POR EMAIL",
                    "DELETE_TICKET": "ELIMINAR TICKET",
                    "DELETE_TICKET_MODAL": {
                        "TITLE": "¿Eliminar ticket?",
                        "MESSAGE":"¿Estás segura de que quieres eliminar el ticket? <strong>{{title}}</strong>",
                        "CANCEL": "CANCELAR",
                        "DELETE": "ELIMINAR"
                    },
                    "LOW": "bajo",
                    "MEDIUM": "medio",
                    "HIGH": "alto",
                    "CHOOSE_TICKET": "Elige billete",
                    "ERRORS": {
                        "TICKET_ALREADY_ATTACHED": "Boleto ya adjunto.",
                        "ERROR_OCCURED": "Se ha producido un error.",
                        "PERMISSION_DENIED": "Permiso denegado.",
                        "MISSING_PARAMETERS": "Faltan parametros",
                        "FILE_ALREADY_EXIST": "El archivo ya existe"
                    },
                    "FILES": "Archivos",
                    "UPLOAD_FILE": "SUBIR ARCHIVO"
                },
                "ARCHIVES": {
                    "ARCHIVE_LIST": {
                        "LOADING": "Cargando",
                        "CREATED_AT": "Creado en",
                        "SIZE": "Tamaño",
                        "STATUS": "Estado",
                        "DOWNLOAD": "Descargar",
                        "AVAILABLE": "disponible",
                        "DISCONNECTED": "desconectada",
                        "DELETED": "eliminada",
                        "EXPIRED": "caducada",
                        "WAITING": "esperando",
                        "FAILED": "fallida",
                        "REFRESH": "Actualizar",
                        "NO_ARCHIVE_MESSAGE": "No hay registro de videollamada",
                        "NAME": "Nombre",
                        "STORAGE": "Almacenamiento",
                        "DURATION": "Duración",
                        "ARCHIVES": "Registros de videollamadas",
                        "PLAY": "Jugar",
                        "DELETE": "Borrar",
                        "DOWNLOAD_ARCHIVE": {
                            "TITLE": "Descargar Registro",
                            "GENERATING": "Generando URL de descarga",
                            "GENERATED": "URL de descarga generada",
                            "CANNOT_GENERATED": "No se puede generar la URL de descarga.",
                            "DOWNLOAD": "Descargar",
                            "CLOSE": "Cerrar"
                        },
                        "DELETE_ARCHIVE": {
                            "TITLE": "Eliminar el registro",
                            "MESSAGE": "Se eliminará el registro de la videollamada.",
                            "CAUTION": "PRECAUCIÓN: Este registro también se eliminará de su almacenamiento de Azure.",
                            "CANCEL": "Cancelar",
                            "DELETE": "Borrar"
                        }
                    }
                },
                "CONVERTER": {
                    "TITLE": "Convertidor",
                    "STP_ONLY": "Solo se admiten los formatos de archivo .stp y .step.",
                    "ERROR_UPLOAD": "Se produjo un error al cargar el archivo.",
                    "DRAG": "Arrastra y suelta tu archivo aquí",
                    "OR": "o",
                    "CHOOSE": "Elija el archivo",
                    "CONVERT": "Convertir",
                    "SUPPORTED": "Formatos de archivo admitidos:",
                    "BACK": "Volver",
                    "DOWNLOAD": "Descargar",
                    "ERROR_LOAD": "Se produjo un error al cargar el objeto."
                },
                "WHATSNEW": {
                    "WHATSNEW_TITLE": "Qué hay de Nuevo",
                    "NO_UNREAD_UPDATE": "No hay actualizaciones no leídas"
                },
                "JOIN_MODAL": {
                    "JOIN" : "UNIRSE",
                    "CALL": "LLAMADA",
                    "CANCEL": "CANCELAR",
                    "MIRROR_VIDEO": "Efecto Espejo Video",
                    "PREFERRED_RESOLUTION": "Resolución preferida",
                    "RESOLUTION_NOTE": "Nota: si su dispositivo no admite la resolución que solicitó, se utilizará la siguiente resolución más grande.",
                    "CAM_MIC_PERM_REQUIRED": "Se requieren permisos de cámara y micrófono",
                    "CAM_MIC_PERM_DENIED": "Acceso denegado a cámara y micrófono",
                    "CAM_MIC_CANT_ACCESS": "No podemos acceder a tu cámara o micrófono",
                    "JOIN_CAM_OFF": "Unirse con la cámara apagada",
                    "JOIN_MIC_OFF": "Unirse con el micrófono apagado",
                    "JOIN_CAM_MIC_OFF": "Unirse con cámara y micrófono apagados",
                    "JOIN_NO_DEVICE": "Unirse sin cámara y micrófono",
                    "ALLOW_ACCESS": "Debe permitir el acceso a su cámara y micrófono en la configuración de su navegador (después de otorgar acceso, aún puede apagar su cámara o micrófono).",
                    "TRY_AGAIN": "Vuelva a intentarlo/actualice la página y seleccione 'Permitir' cuando se lo solicite su navegador."
                },
                "NO_DEVICE_MODAL": {
                    "TITLE": "Ningún dispositivo encontrado",
                    "JOIN_BODY": "No hay micrófono ni cámara conectados a este dispositivo. Otros usuarios no podrán escucharlo ni verlo a través de este dispositivo. ¿Todavía quieres unirte?",
                    "CALL_BODY": "No hay micrófono ni cámara conectados a este dispositivo. Otros usuarios no podrán escucharlo ni verlo a través de este dispositivo. ¿Todavía quieres llamar?",
                    "CANCEL": "Cancelar",
                    "JOIN": "De Todas Maneras, Unirse",
                    "CALL": "De Todas Maneras, Llamada"
                },
                "AGREEMENT_MODAL": {
                    "TITLE": "Formulario de aprobación de procesamiento y seguridad de datos personales",
                    "REJECTION_BUTTON": "Rechazar",
                    "AGREEMENT_BUTTON": "De acuerdo"
                },
                "CHECK_AGREEMENT_MODAL": {
                    "TITLE": "Cancelar el contrato?",
                    "ERROR": "Ocurrió un error.",
                    "STATEMENT": "Cuando no acepta el contrato, no podrá iniciar sesión en el sistema.",
                    "CANCEL_BUTTON": "Cancelar",
                    "PROCEED_BUTTON": "Continuar"
                },
                "JOIN_UNKNOWN_ERROR" : "Ocurrió un error al unirse a la sala.",
                "JOIN_CONCURRENT_ERROR" : "Has llegado al límite de los usuarios concurrentes de tu cuenta. Contacta con tu administrador para más detalles.",
                "JOIN_EXPERT_CONCURRENT_ERROR" : "Has llegado al límite de los usuarios concurrentes de tu cuenta. Contacta con tu administrador para más detalles.",
                "NO_TRAINING_LICENSE": "Hay un problema con la licencia de la sala de formación. Contacta a tu administrador.",
                "TRAINING_LICENSE_EXPIRED": "Su licencia de sala de formación ha caducado. Contacta a tu administrador.",
                "ASK_TRAINING_HOST": "Ocurrió un error al ingresar a la sala de capacitación. Comuníquese con el anfitrión.",
                "JOIN_CALL_IN_PROGRESS": "Hay otra llamada en la sala de reuniones de su personal.",
                "NOT_SUPPORTED_TITLE": "Navegador no compatible",
                "NOT_SUPPORTED_MESSAGE": "Tu navegador no es compatible. Por favor utiliza Google Chrome, Mozilla Firefox, Safari or Microsoft Edge (versión 79 o más reciente).",
                "NO_IOS_MESSAGE": "Tu navegador no es compatible. Por favor utilice la aplicación {{ appName }} o Safari.",
                "IOS_VERSION_MESSAGE": "Tu navegador no es compatible. Por favor utilice la aplicación {{ appName }}.",
                "NOT_SUPPORTED_CLOSE": "Cerrar",
                "IDLE_MODAL_TITLE": "Error",
                "IDLE_MODAL_MESSAGE": "No has utilizado el sistema por un tiempo.",
                "IDLE_MODAL_COUNT": "Tu sesión será cerrada en {{ count }} segundos.",
                "IDLE_MODAL_OK": "¡Aquí estoy!",
                "ARCHIVE_PERMISSION_MODAL": {
                    "TITLE": "¿Permitir grabación?",
                    "MESSAGE": "Se grabará la reunión en esta sala. Debes permitir la grabación de video para poder unirte a esta sala.",
                    "DENY": "Negar",
                    "ALLOW": "Permitir"
                }
            },
            "ROOM" : {
                "OT_ERROR_MODAL": {
                    "TITLE": "Error",
                    "CLOSE": "De Todas Maneras, Continúe",
                    "REJOIN": "Reunirse Con",
                    "ENDCALL": "Dejar",
                    "ERRORS": {
                        "INTERNET": "No se puede conectar a la sesión. Verifique su conexión a Internet.",
                        "TRY_AGAIN": "Ocurrió un error al conectarse a la sesión. Por favor reintente más tarde.",
                        "UNKNOWN": "Ocurrió un error al conectarse a la sesión.",
                        "PUBLISHER_FAILED": "No se pudo compartir tu transmisión de video con otros participantes.",
                        "PUBLISHER_CAM_MIC_ACCESS": "Asegúrese de que su cámara y micrófono estén funcionando y que se otorguen permisos de cámara/micrófono.",
                        "SUBSCRIBER_FAILED": "No se pudo conectar a una de las secuencias de video de los participantes."
                    }
                },
                "SIDEBAR" : {
                    "CHAT_TITLE" : "Chat",
                    "PARTICIPANTS_TITLE" : "Participantes",
                    "FILES_TITLE" : "Archivos",
                    "SETTINGS_TITLE" : "Opciones",
                    "SHOW_TICKET": "Mostrar boleto",
                    "ATTACH_TO_TICKET": "Adjuntar al ticket",
                    "ATTACH_SESSION_TO_TICKET": "Adjuntar sesión al ticket",
                    "OPEN_WORKFLOW": "Flujo de trabajo abierto",
                    "CHAT" : {
                        "SEE_TRANSLATION": "Ver Traducción",
                        "SEE_ORIGINAL": "Ver Original",
                        "TRANSLATING": "Traduciendo",
                        "FILE_SHARE" : {
                            "DRAG_HERE" : "Arrastra archivos aquí",
                            "UPLOAD_TITLE": "Subir archivos",
                            "IMAGE": "Imagen",
                            "PDF": "Pdf",
                            "3D_OBJECT": "Objecto 3D",
                            "OTHER": "Otros",
                            "MULTIPLE_OBJECTS": "Encontramos múltiples objetos en tus archivos. Por favor suba un objeto (con sus texturas si aplica) a la vez.",
                            "LARGER_THAN": "Más de {{ megabytes }} MB",
                            "FILETYPE_PROHIBITED": "Tipo de archivo prohibido",
                            "START_UPLOAD": "SUBIR",
                            "CANCEL_UPLOAD": "DETENER",
                            "CLOSE_UPLOAD": "CERRAR",
                            "CANCEL_MODAL_TITLE": "¿Detener subida?",
                            "CANCEL_MODAL_MESSAGE": "Esto cancelará los elementos que están siendo subidos.",
                            "CANCEL_MODAL_CLOSE": "Cancelar",
                            "CANCEL_MODAL_CANCEL": "Detener"
                        },
                        "DELETE_FILE_MODAL": {
                            "TITLE": "¿Eliminar archivo?",
                            "MESSAGE": "Este archivo será eliminado",
                            "CLOSE": "Cerrar",
                            "DELETE": "Eliminar"
                        },
                        "FILE_DETAILS_MODAL": {
                            "TITLE": "Detalles del Archivo",
                            "FILENAME": "Nombre de archivo",
                            "SIZE": "Tamaño",
                            "TYPE": "Tipo",
                            "UPLOAD_TIME": "Tiempo de subida",
                            "DOWNLOAD": "Descargar",
                            "CLOSE": "Cerrar",
                            "FILECOUNT": "Recuento total de archivos"
                        },
                        "COLLABORATE": "Colaborar",
                        "CLOSE_COLLABORATION": "Cerrar Colaboración",
                        "DOWNLOAD": "Descargar",
                        "DELETE": "Eliminar",
                        "DETAILS": "Detalles",
                        "SEND_TO_FILES": "Enviar a Archivos",
                        "FILE_DELETED": "Archivo eliminado",
                        "JOIN_ROOM" : "{{ owner_info }} se unió a la sala.",
                        "LEAVE_ROOM" : "{{ owner_info }} abandonó la sala.",
                        "REACTION": "{{ owner_info }} envió una reacción.",
                        "REQUEST_SCREENSHOT": "{{ owner_info }} solicitó una instantánea.",
                        "SHARE_SCREENSHOT" : "{{ owner_info }} compartió una instantánea.",
                        "SAVED_COLLABORATION": "Colaboración guardada.",
                        "SHARE_IMAGE" : "{{ owner_info }} compartió una imagen.",
                        "SHARE_PDF" : "{{ owner_info }} compartió un pdf.",
                        "SHARE_OTHER" : "{{ owner_info }} compartió un archivo.",
                        "SHARE_OBJECT" : "{{ owner_info }} compartió un Objeto 3D.",
                        "COLLABORATED" : "{{ owner_info }} comenzó una colaboración.",
                        "TYPE_HERE" : "escriba aquí...",
                        "PLEASE_WAIT_OTHERS": "Por favor espere que otros usuarios se unan.",
                        "DOWNLOAD_STARTED_SOON": "La descarga comenzará pronto.",
                        "DOWNLOAD_FAILED": "Descarga fallida.",
                        "DOWNLOAD_OBJECT_NOT_SUPPORTED": "La descarga de objeto aún no es soportada.",
                        "DOWNLOAD_NOT_SUPPORTED": "Descarga aún no es soportada.",
                        "CLOSE_PREV_COLLABORATION_TITLE": "¿Cerrar la colaboración de archivos actual?",
                        "CLOSE_COLLABORATION_TITLE": "¿Cerrar la colaboración de archivos?",
                        "CLOSE_PREV_COLLABORATION_MESSAGE": "Esto cerrará la colaboración de archivos actual y comenzará una nueva.",
                        "CLOSE_COLLABORATION_MESSAGE": "Esto cerrará la colaboración de archivos.",
                        "CLOSE_PREV_COLLABORATION_YES": "Aceptar",
                        "CLOSE_PREV_COLLABORATION_NO": "Cancelar",
                        "DISABLE_FOCUS_MODAL": {
                            "TITLE": "¿Colaboración de archivos abierta?",
                            "MESSAGE_AUTHORIZED": "Existe una ventana anclada. ¿Quieres desanclarlo y abrir la colaboración de archivos?",
                            "MESSAGE_UNAUTHORIZED": "No se puede abrir la colaboración de archivos porque existe una ventana anclada.",
                            "CANCEL": "Cancelar",
                            "CLOSE": "Cerca",
                            "PROCEED": "Continuar"
                        },
                        "CLOSE_ARPLUS_BEFORE_COLL": {
                            "TITLE": "Cerrar AR+?",
                            "MESSAGE": "Debe cerrar AR+ antes de poder abrir la colaboración. ¿Seguro que quieres cerrar AR+?",
                            "NO": "No",
                            "YES": "Sí"
                        }
                    },
                    "PARTICIPANTS": {
                        "HOST": "(Gerente)",
                        "LOWER_ALL_HANDS": "Bajar todas las manos",
                        "RAISED_HAND": "{{ name }} levantó la mano.",
                        "DENIED_PUBLISH": "{{ name }} negó unirse a la comunicación de video/audio.",
                        "PARTICIPANT_LIMIT_REACHED": "Se alcanzó el límite de participantes de comunicación de video/audio.",
                        "CALLING": "Vocación: {{ participants }}"
                    },
                    "FILES": {
                        "INFO_TEXT": "Todos los expertos y coadministradores que tengan acceso a esta sala pueden ver y modificar los archivos de esta sección.",
                        "DOWNLOAD": "Descargar",
                        "SEND_TO_SESSION": "Enviar a sesión",
                        "DELETE": "Borrar",
                        "UPLOAD_FILE": "Subir archivo",
                        "FILE_CONTENTS": "Contenido del archivo:",
                        "FILE_NAME": "Nombre del archivo:",
                        "FILE_SIZE": "Tamaño del archivo:",
                        "TOTAL_SIZE": "Tamaño total:",
                        "DOWNLOAD_STARTED_SOON": "La descarga comenzará pronto.",
                        "DOWNLOAD_FAILED": "Descarga fallida.",
                        "DELETE_MODAL": {
                            "TITLE_DELETE": "Borrar archivo?",
                            "MESSAGE_DELETE": "Estás seguro de que quieres eliminar este archivo?",
                            "CANCEL": "Cancelar",
                            "DELETE": "Borrar"
                        }
                    },
                    "SETTINGS": {
                        "MICROPHONE": "Micrófono",
                        "CAMERA": "Cámara",
                        "TRANSLATE_OTHERS_MSG_TO": "Traducir Otros Mensajes a:",
                        "TRANSLATE_MY_MSG_TO": "Traducir mis Mensajes a:",
                        "CREATE_GUEST_ACCESS": "Crear acceso de invitado",
                        "GENERATING": "Generando",
                        "GUEST_ACCESS": "Acceso para invitados",
                        "COPY_LINK": "Copiar",
                        "LINK_COPIED": "Enlace copiado al portapapeles.",
                        "LINK_GENERATED": "Se generó el enlace para unirse a la sesión.",
                        "CANNOT_CREATE_GUEST_ACCESS": "No se puede crear acceso de invitado.",
                        "NO_LINK_PERMISSION": "No tienes permiso para crear un enlace de acceso de invitado. Comuníquese con su administrador.",
                        "SHARE": "Cuota",
                        "SHARE_LINK_VIA_SMS": "Compartir enlace a través de SMS",
                        "SMS_SEND": "Enlace enviado por SMS",
                        "OPENING": "Apertura",
                        "SEND": "Enviar",
                        "SMS_LIMIT_REACHED": "Se alcanzó el límite de envío de SMS. Comuníquese con su administrador.",
                        "ERROR_OCCURED": "Ocurrió un error.",
                        "SMS_LICENSE_PERMISSION": "No tienes permiso para enviar SMS. Comuníquese con su administrador.",
                        "RESHARE": "Puede compartir el enlace una vez por minuto.",
                        "DIDNT_GET": "¿No recibiste el enlace?",
                        "PHONE_NUMBERS": "Números de teléfono usados recientemente",
                        "RESEND": "Reenviar.",
                        "CANCEL": "Cancelar",
                        "CONNECT_VIA_FIELD_CODE": "Conéctese con la usuario a través de Field ID",
                        "CONNECT": "Conectar",
                        "INVITATION_SENT": "La invitación ha sido enviada a la usuaria.",
                        "INVITATION_COULD_NOT_SENT": "No se pudo enviar la invitación al usuario.",
                        "FIELD_CODE": "Field ID"
                    }
                },
                "VIDEO_CHAT" : {
                    "AUDIO_BITRATE": "Bitrate de audio",
                    "AUDIO_PACKET_LOSS": "Pérdida de paquetes de audio",
                    "VIDEO_BITRATE": "Bitrate de vídeo",
                    "VIDEO_PACKET_LOSS": "Pérdida de paquetes de vídeo",
                    "RESOLUTION": "Resolución",
                    "WAIT_OTHER_USERS" : "Por favor espere que otros usuarios se unan.",
                    "WAIT_EXPERT": "Por favor espere que el experto se una.",
                    "WAIT_MASTER": "Espere a que el Gerente comience la sesión.",
                    "START_SESSION": "INICIAR SESIÓN",
                    "HOST_WITHDRAW_REQUEST": "Gerente retira la solicitud de video/audio.",
                    "NO_CAM_MIC": "Su cámara y micrófono no están disponibles.",
                    "NO_CAM": "Su cámara no está disponible.",
                    "NO_MIC": "Su micrófono no está disponible.",
                    "JOIN_VIDEO_AUDIO_MODAL": {
                        "TITLE": "Únete a la comunicación de video/audio?",
                        "MESSAGE": "El Gerente desea que habilite su video / audio.",
                        "DENY": "Negar",
                        "ACCEPT": "Aceptar"
                    },
                    "PUBLISHER" : {
                        "YOU": "Tu",
                        "SCREEN_SHARE_MESSAGE": "Estás compartiendo tu pantalla",
                        "STOP_SCREEN_SHARING": "Dejar de compartir"
                    },
                    "SUBSCRIBER" : {
                        "APP_NOT_UP_TO_DATE_FOR_STATS": "No se puede mostrar el estado de la red porque la aplicación de este participante no está actualizada.",
                        "SNAPSHOT": "Instantánea",
                        "AR_PLUS": "Colaboración AR+",
                        "SCREENSHOT_REQUESTED": "Instantánea solicitada",
                        "VIDEO_NOT_AVAILABLE": "El video no está disponible",
                        "WEAK_SIGNAL": "Señal debil",
                        "AUDIO_ONLY_MODE": "Modo solo Audio",
                        "FLASH": "Flash",
                        "AR_NOT_AVAILABLE": "AR+ no disponible en éste dispositivo.",
                        "CHARGING": "Cargando",
                        "LOW_BATTERY": "Batería baja",
                        "CLOSE_AR_PLUS_MODAL": {
                            "TITLE": "Cerrar AR+?",
                            "MESSAGE": "¿Estás seguro que deseas cerrar AR+?",
                            "NO": "No",
                            "YES": "Sí"
                        },
                        "DISABLE_FOCUS_MODAL": {
                            "TITLE": "Abrir AR+?",
                            "MESSAGE_AUTHORIZED": "Existe una ventana anclada. ¿Desea desanclarlo y abrir AR+?",
                            "MESSAGE_UNAUTHORIZED": "El AR+ no se puede abrir porque existe una ventana anclada.",
                            "CANCEL": "Cancelar",
                            "CLOSE": "Cerca",
                            "PROCEED": "Continuar"
                        },
                        "REFRESH_SURFACES": "Actualizar superficies",
                        "AR_PLUS_LOCKED": "AR+ está bloqueado. Desbloquee AR+ primero."
                    },
                    "CONTROL_BAR": {
                        "SHARE_SCREEN": "Compartir pantalla",
                        "STOP_SHARE": "Dejar de compartir",
                        "MIC_OFF": "Micrófono",
                        "CAM_OFF": "Cámara",
                        "CAM_MIC_CANT_ACCESS": "No podemos acceder a tu micrófono o cámara",
                        "LEAVE_CALL": "Dejar",
                        "LEAVE_SESSION": "Salir de la sesión",
                        "LEAVE_MEETING": "Salir de la reunión",
                        "END_SESSION_FOR_ALL": "¿Finalizar sesión para todos?",
                        "END_MEETING_FOR_ALL": "Finalizar la reunión para todos",
                        "ENDCALL_MODAL": {
                            "TITLE_LEAVE": "¿Salir de la sesión?",
                            "TITLE_LEAVE_MEETING": "¿Salir de la reunión?",
                            "TITLE_END_ALL": "¿Finalizar sesión para todos?",
                            "TITLE_END_ALL_MEETING": "¿Finalizar la reunión para todos?",
                            "MESSAGE_LEAVE": "¿Estás seguro de que quieres salir de la sesión?",
                            "MESSAGE_END_ALL": "¿Estás segura de que quieres terminar la sesión?",
                            "MESSAGE_LEAVE_MEETING": "¿Estás seguro de que quieres abandonar la reunión?",
                            "MESSAGE_END_ALL_MEETING": "¿Estás segura de que quieres terminar la reunión?",
                            "CANCEL": "Cancelar",
                            "END": "Aceptar",
                            "LEAVE": "Salir",
                            "REMOVE_MEETING_LINK": "También deshabilite y elimine el enlace de la reunión"
                        },
                        "RAISE_HAND": "Levantar la mano",
                        "LOWER_HAND": "Mano inferior",
                        "RECORD": "Grabar",
                        "AUTO_RECORD": "Grabar automáticamente",
                        "STOP_RECORD": "Detener grabación",
                        "CANCEL": "Cancelar petición",
                        "ASK_ARCHIVE_PERMISSION": "Pide permiso de grabación",
                        "REACTION": "Reacción",
                        "EXTENSION_MODAL_TITLE": "Se requiere una extensión",
                        "EXTENSION_MODAL_MESSAGE": "Google Chrome requiere una extensión para compartir pantalla. Por favor instálela o utilice Mozilla Firefox",
                        "EXTENSION_MODAL_NO": "Cancelar",
                        "EXTENSION_MODAL_YES": "Abrir página de la extensión",
                        "ARCHIVE_NO_PERMISSION": "No tienes permiso para grabar ésta sesión. Contacta a tu Administrador.",
                        "P2P_NO_ARCHIVE": "Grabación no disponible para llamadas P2P. Contácta a tu Administrador.",
                        "SCREEN_SHARE_UPDATE": "La versión actual de su navegador no admite el uso compartido de pantalla. Por favor actualice su navegador.",
                        "SCREEN_SHARE_NOT_SUPPORTED": "Tu navegador no permite compartir pantalla.",
                        "SCREEN_SHARE_USE_OTHER": "Tu navegador no permite compartir pantalla. Por favor utiliza Google Chrome o Mozilla Firefox.",
                        "SCREEN_SHARE_FAILED": "No se puede compartir la pantalla.",
                        "ARCHIVE_REQUESTED": "Se iniciará la grabación de video. Se requiere su permiso.",
                        "ARCHIVE_REQUESTED_WITH_NAME": "{{ name }} quiere comenzar a grabar un video. Se requiere su permiso.",
                        "DENY": "Negar",
                        "ALLOW": "Permitir"
                    },
                    "PDF_COLLABORATION": {
                        "PREVIOUS_PAGE": "Página anterior",
                        "NEXT_PAGE": "Página siguiente"
                    },
                    "COLLABORATION_SHARED": {
                        "SOME_USERS_CANNOT_LOAD": "Algunos usuarios no pueden cargar la colaboración de archivos.",
                        "DOWNLOAD_FAILED": "No se puede descargar la colaboración de archivos.",
                        "END_COLL_TITLE": "¿Cerrar la colaboración de archivos?",
                        "END_COLL_MESSAGE": "Esto cerrará la colaboración de archivos.",
                        "END_COLL_NO": "Cancelar",
                        "END_COLL_YES": "Aceptar",
                        "ALREADY_ENDED": "La colaboración de archivos ya terminó.",
                        "CANNOT_END_COLLABORATION": "No se puede finalizar la colaboración de archivos.",
                        "ANNOTATE": "Anotar",
                        "FULLSCREEN": "Pantalla Completa",
                        "DOWNLOAD_COLLABORATION": "Descargar Colaboración",
                        "SNAPSHOT_COLLABORATION": "Instantánea",
                        "UNDO": "Deshacer",
                        "REDO": "Rehacer",
                        "REVERT": "Revertir",
                        "RELOAD": "Recargar"
                    },
                    "TRY_TO_FOCUS_MODAL": {
                        "TITLE": "Pin ventana?",
                        "MESSAGE": "El pin durante el modo AR+ no es posible. ¿Cerrar AR+ y pin?",
                        "CANCEL": "Cancelar",
                        "PROCEED": "Continuar"
                    }
                }
            },
            "RECONNECT_ROOM": {
                "RECONNECT_MESSAGE": "Parece que ha habido un problema. Estamos intentando conectarle de nuevo con la llamada."
            },
            "SESSION_RATING": {
                "BAD": "Malo",
                "POOR": "Inadecuado",
                "FAIR": "Durchschnitt",
                "GOOD": "Promedio",
                "EXCELLENT": "Excelente",
                "RATING_MESSAGE" : "¿Cómo fue la calidad de la sesión?",
                "REVIEW_MESSAGE" : "Cuéntanos por qué (opcional)",
                "SUCCESS_MESSAGE": "Gracias por calificar la sesión.",
                "CLOSE": "Cerrar",
                "SUBMIT": "Enviar",
                "DISMISS": "Rechazar"
            },
            "PRECALL_TEST": {
                "BACK_TO_LOBBY": "Volver al Lobby",
                "RUN_PRECALL_TEST": "Realizar Comprobación de Conexión",
                "WHAT_TEST": {
                    "TITLE": "Vamos a comprobar la conexión",
                    "CONNECTIVITY": "Conectividad a los Servidores.",
                    "STATS": "Recolectar estadísticas de Bitrate y Pérdida de Paquetes.",
                    "SETUP": "Configuración de Hardware & Software en el extremo (Cámara, Micrófono, Navegador)."
                },
                "BEFORE_START": {
                    "TITLE": "Antes de empezar",
                    "MAKE_SURE": "Asegurate que;",
                    "RIGHT_NETWORK": "Estás conectado en la red que deseas comprobar la conexión.",
                    "TCP_PORT_OPEN": "Posees al menos el puerto TCP 443 abierto.",
                    "RIGHT_HARDWARE": "Has seleccionado la cámara y micrófono correctos.",
                    "BANDWITH": "Tu ancho de banda es de al menos 350kbps para subida y bajada."
                },
                "HARDWARE_SOFTWARE": {
                    "TITLE": "Configuración de Hardware/Software",
                    "OPERATING_SYSTEM": {
                        "MESSAGE": "Sistema Operativo",
                        "BETTER_ALTERNATIVE_IOS": "Puedes descargar la aplicación {{ appName }} Remote desde el AppStore para una mejor experiencia.",
                        "BETTER_ALTERNATIVE_ANDROID": "Puedes descargar la aplicación {{ appName }} Remote desde Google Play Store para una mejor experiencia."
                    },
                    "BROWSER": {
                        "MESSAGE": "Navegador",
                        "NOT_SUPPORTED": "Tu navegador no está soportado. Por favor utiliza Google Chrome, Mozilla Firefox, Safari or Microsoft Edge (versión 79 o más reciente).",
                        "NOT_COMPATIBLE": "Tu navegador no es compatible. Por favor actualiza tu navegador.",
                        "USE_SAFARI": "Tu navegador no es compatible. Por favor utiliza la aplicación {{ appName }} Remote o utiliza Safari."
                    },
                    "HARDWARE": {
                        "MESSAGE": "Acceso a Cámara / Micrófono",
                        "CANT_ACCESS": "No podemos acceder a tu cámara / micrófono."
                    }
                },
                "CONNECTION_SERVERS": {
                    "TITLE": "Conexión a Nuestros Servidores",
                    "INTERNET": {
                        "MESSAGE": "Conexión a Internet",
                        "OFFLINE": "Tu conexión a Internet parece estár desconectada."
                    },
                    "SERVERS": {
                        "MESSAGE": "Conexión a Nuestros Servidores",
                        "UNKNOWN_ERROR_TRY": "Ocurrió un error al intentar conectar a nuestros servidores. Por favor reintente más tarde.",
                        "UNKNOWN_ERROR": "Ocurrió un error al conectar a nuestros servidores."
                    }
                },
                "QUALITY": {
                    "TITLE": "Calidad de Audio/Video",
                    "AUDIO_VIDEO": {
                        "MESSAGE": "Calidad de Audio/Video",
                        "UNKNOWN_ERROR": "Ocurrió un error al comprobar la calidad de audio/video.",
                        "VIDEO": "Video",
                        "VIDEO_QUALITY": "Calidad de Video: ",
                        "VIDEO_PACKET_LOSS": "Pérdida de Paquetes: ",
                        "VIDEO_BITRATE": "Bitrate de Video: ",
                        "AUDIO": "Audio",
                        "AUDIO_QUALITY": "Calidad de Video Audio: ",
                        "AUDIO_PACKET_LOSS": "Pérdida de Paquetes: ",
                        "AUDIO_BITRATE": "Bitrate de Audio: ",
                        "QUALITY_EXCELLENT": "(Excelente)",
                        "QUALITY_GOOD": "(Bueno)",
                        "QUALITY_BAD": "(Inferior)"
                    }
                },
                "STOP_TEST_MODAL": {
                    "TITLE": "¿Detener comprobación?",
                    "MESSAGE": "Esto detendrá la comprobación de conexión.",
                    "NO": "Cancelar",
                    "YES": "Aceptar"
                }
            },
            "EMAIL_RECIPIENTS": {
                "PLACEHOLDER": "Añadir nueva",
                "SECONDARY_PLACEHOLDER": "Introduzca la dirección de correo electrónico",
                "INVALID_EMAIL": "Formato de correo inválido."
            },
            "WORKFLOW_REMOTE": {
                "ERRORS": {
                    "INTEGRATION_ALREADY_USED": "Integración ya utilizada",
                    "MISSING_PARAMETERS": "Faltan parámetros",
                    "CALL_IN_PROGRESS": "La llamada está en curso",
                    "USER_IN_ANOTHER_ROOM": "Usuario en otra habitación"
                }
            }
        },
        "HELP_CENTER": {
            "TITLE": "{{ appName }} Centro de ayuda",
            "TITLE_WITH_REMOTE": "{{ appName }} Remoto Centro de ayuda",
            "FAILED": "Ocurrió un error."
        },
        "EXTERNALS": {
            "JOIN_WITH_LINK": {
                "TITLE": "{{appName}} Acceso de invitado remoto",
                "SESSION_NOT_FOUND": "La sesión que has solicitado no pudo ser encontrada.",
                "SESSION_NOT_AVAILABLE": "La sesión ya no está disponible.",
                "CONCURRENT_LIMIT_REACHED": "Límite de usuarios concurrentes alcanzado. Contacta a tu Administrador.",
                "EXPERT_CONCURRENT_LIMIT_REACHED": "Límite de usuarios concurrentes alcanzado. Contacta a tu Administrador.",
                "UNKNOWN_ERROR": "Algo falló.",
                "ABOUT_TO_JOIN": "Estás a punto de conectarte",
                "ENTER_NAME": "Ingresa tu nombre",
                "NAME_REQUIRED": "Debes ingresar tu nombre",
                "NAME_SHORT": "El nombre debe tener al menos dos caractéres",
                "JOIN": "UNIRSE",
                "CONTINUE_TO_WEBSITE": "Continuar a través del Navegador"
            },
            "ARCHIVE_LIST": {
                "TITLE": "Registros de videollamadas",
                "LOADING": "Cargando",
                "LOAD_FAILED": "Ocurrió un error.",
                "CREATED_AT": "Creado en",
                "SIZE": "Tamaño",
                "STATUS": "Estado",
                "DOWNLOAD": "Descargar",
                "GENERATING": "Generando enlace",
                "CLICK_TO_DOWNLOAD": "Haga clic para descargar",
                "AVAILABLE": "disponible",
                "DISCONNECTED": "desconectada",
                "DELETED": "eliminada",
                "EXPIRED": "caducada",
                "WAITING": "esperando",
                "FAILED": "fallida"
            },
            "AUTHENTICATE": {
                "MESSAGE": "Ocurrió un error."
            },
            "AD_LOGIN": {
                "MESSAGE": "Ocurrió un error."
            },
            "AD_ERROR": {
                "ACCOUNT_NOT_FOUND": "Su cuenta no está conectada a Azure AD.",
                "PERMISSION_DENIED": "No tienes permiso para ver esta página.",
                "INTERNAL_ERROR": "Ocurrió un error.",
                "CONTACT_MAIL": "Por favor contactanos en <strong>{{ contactMail }}</strong>"
            }
        },
        "TUTORIALS": {
            "TUTORIAL_LINK": "Ver el tutorial de inicio",
            "NEXT": "Siguiente",
            "END": "Terminar",
            "MIC_CAMERA": "Abrir / cerrar el micrófono o cámara",
            "END_CALL": "Salir de la sesión",
            "RECORD": "Iniciar / Detener la grabación para las sesiones",
            "SCREEN_SHARING": "Iniciar / Detener la pantalla compartida a otros usuarios",
            "REACTION": "Enviar una reacción a todos, util cuando la comunicación de voz no es suficiente",
            "OPEN_AR_PLUS": "Abrir AR+",
            "DRAW_ON_SURFACE": "Dibujar en una superficie destacada con una grilla azul en vivo con AR+",
            "OPEN_AR": "Abrir AR",
            "HOLD_TO_HIGHLIGHT": "Mantener presionado el click izquierdo en cualquier punto para destacar un área específica en un stream en vivo con AR",
            "TAKE_SNAPSHOT": "Tomar una instantánea de alta calidad desde otro usuario",
            "NO_CAMERA": "La cámara del otro participante debe estar encendida",
            "WAIT_OR_SKIP": "Esperar a otro usuario o saltar ésta característica",
            "COLLABORATE": "Colaborar en una instantánea: dibuja, agrega diagramas, figuras especiales y textos",
            "OPEN_ANNOTATION": "Abrir anotación",
            "SKETCH_ON_COLL": "Dibujar en el panel de colaboración",
            "END_TUTORIAL": "Puedes acceder a éste tutorial en cualquier momento desde aquí",
            "USER_TUTORIAL": "Tutorial de usuario",
            "GUIDE": "Este tutorial para el usuario lo guiará paso a paso a través de la plataforma.",
            "DONT_SHOW": "No vuelvas a aparecer",
            "SKIP_TUTORIAL": "Saltar tutorial",
            "CANCEL": "Cancelar",
            "SKIP": "Saltar",
            "ASK_AGAIN": "¿Estás segura de que quieres saltar este tutorial?"
        },
        "NOT_FOUND": {
            "PAGE_NOT_FOUND": "Lo sentimos, la página que solicitaste no pudo ser encontrada.",
            "NO_LONGER_AVAILABLE": "La URL puedes estar mal escrita o la página que estás buscando ya no está disponible."
        },
        "DOWNLOADS": {
            "FILE_NOT_FOUND": "Archivo no encontrado",
            "IF_DOWNLOAD_NOT_STARTED": "Si le téléchargement n'a pas commencé, ",
            "CLICK_HERE": "cliquez ici"
        },
    "PAGINATOR": {
        "ITEMS_PER_PAGE": "Elementos por página:",
        "NEXT_PAGE": "Página siguiente",
        "PREVIOUS_PAGE": "Página anterior",
        "FIRST_PAGE": "Primera página",
        "LAST_PAGE": "Última página",
        "RANGE": "{{start}} – {{end}} de {{length}}",
        "RANGE_ZERO": "0 de {{length}}"
    }
}